module.exports = __webpack_public_path__ + "img/img_11@2x.7b266940.png";